import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { TranslateModule } from '@ngx-translate/core';
import { IncidentsReporterSurveyComponent } from '../incidents-reporter-survey/incidents-reporter-survey.component';
import { IncidentsReporterSurvey } from '../../services';
import { RestService } from 'src/app/services';

@Component({
  selector: 'app-incidents-reporter-button',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './incidents-reporter-button.component.html',
  styleUrls: ['./incidents-reporter-button.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IncidentsReporterButtonComponent {  
  private _restService = inject(RestService); // TODO: CAMBIAR PARA SSR AL SERVICIO SUBDOMAIN
  private _incidentsReporterSurveyService = inject(IncidentsReporterSurvey);
  private _matBottomSheet = inject(MatBottomSheet);
    
  public openBottomSheet(): void {
     this._matBottomSheet.open(IncidentsReporterSurveyComponent, {
        panelClass: 'incidents-reporter-survey-bottom-sheet'
     });
  } 
  
  protected prefetchSurveyData(): void {
    const subdomain = this._restService.subDomain;
    if (!subdomain) return;
    
    this._incidentsReporterSurveyService.setSurveyDataServiceSignal(subdomain);
  }
  
}
